var _clipPath, _clipPath2, _clipPath3, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 95,
    viewBox: "0 0 70 95",
    width: 70,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m56.681 98h70v95h-70z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h338.437v66.608h-338.437z"
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h338.425v66.608h-338.425z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "translate(-56.681 -98)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(57 112.264)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#4d4d4f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m521.809 376.778a9.06 9.06 0 0 1 -9.162 9.069 8.152 8.152 0 0 1 -8.046-5.162v4.8h-1.638v-25.09h1.637v12.476a8.193 8.193 0 0 1 8.046-5.092 9 9 0 0 1 9.162 9m-1.6 0a7.584 7.584 0 0 0 -7.784-7.564 7.586 7.586 0 1 0 0 15.164 7.591 7.591 0 0 0 7.784-7.6",
    transform: "translate(-415.929 -339.581)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.223 366.072v1.5a4.43 4.43 0 0 0 -1.712-.322 5.27 5.27 0 0 0 -5.179 5.27v11.042h-1.638v-17.347h1.638v3.119a5.9 5.9 0 0 1 5.215-3.477 7.609 7.609 0 0 1 1.676.215",
    transform: "translate(-409.159 -337.659)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m528.232 374.676v.072a7.368 7.368 0 0 0 7.523 7.744c3.351 0 6.145-1.649 6.741-4.267h1.6c-.708 3.442-4.172 5.7-8.38 5.7a9.034 9.034 0 1 1 0-18.068 8.266 8.266 0 0 1 8.529 8.354 2 2 0 0 1 -.037.465zm.111-1.29h14.191a6.6 6.6 0 0 0 -6.853-6.2 7.3 7.3 0 0 0 -7.338 6.2",
    transform: "translate(-406.338 -337.659)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m559.952 366.215v17.351h-1.6v-4.875a8.21 8.21 0 0 1 -8.046 5.234 9.035 9.035 0 1 1 0-18.068 8.182 8.182 0 0 1 8.046 5.2v-4.84zm-1.6 8.641c0-4.374-3.278-7.564-7.859-7.564a7.584 7.584 0 1 0 0 15.164c4.58 0 7.859-3.191 7.859-7.6",
    transform: "translate(-400.481 -337.659)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m562.366 368.835v10.647c0 2.976 1.565 3.979 4.1 3.979a4.588 4.588 0 0 0 1.229-.143v1.434a6.263 6.263 0 0 1 -1.453.143c-3.389 0-5.513-1.613-5.513-5.413v-10.647h-3.649v-1.435h3.649v-4.912h1.639v4.912h5.326v1.434z",
    transform: "translate(-394.033 -338.844)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m583.619 375.415v10.074h-1.6v-9.967a5.935 5.935 0 0 0 -6.294-6.308c-3.912 0-6.481 2.509-6.481 6.308v9.967h-1.644v-25.094h1.639v11.722a6.751 6.751 0 0 1 6.7-4.337c4.656 0 7.673 2.976 7.673 7.636",
    transform: "translate(-389.774 -339.581)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m585.638 362.145a1.414 1.414 0 0 1 -1.415 1.363 1.378 1.378 0 0 1 -1.454-1.363 1.394 1.394 0 0 1 1.454-1.326 1.435 1.435 0 0 1 1.415 1.326m-.638 23.195h-1.639v-17.352h1.639z",
    transform: "translate(-383.638 -339.432)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m604.566 373.493v10.074h-1.6v-9.967a5.935 5.935 0 0 0 -6.294-6.308c-3.911 0-6.481 2.509-6.481 6.308v9.967h-1.641v-17.352h1.639v3.979a6.751 6.751 0 0 1 6.7-4.337c4.656 0 7.673 2.976 7.673 7.636",
    transform: "translate(-381.299 -337.659)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m622.1 366.215v16.921c0 4.767-3.613 7.923-8.79 7.923-4.319 0-8.268-2.223-8.342-5.988h1.564c.038 2.8 3.017 4.625 6.742 4.625 4.246 0 7.225-2.617 7.225-6.525v-4.551a8.182 8.182 0 0 1 -8.045 5.2 8.982 8.982 0 1 1 0-17.961 8.153 8.153 0 0 1 8.045 5.162v-4.8zm-1.6 8.6c0-4.374-3.277-7.528-7.859-7.528a7.532 7.532 0 1 0 0 15.057c4.582 0 7.859-3.155 7.859-7.529",
    transform: "translate(-375.334 -337.659)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m632.817 365.993v3.047a5.991 5.991 0 0 0 -1.787-.288 4.74 4.74 0 0 0 -4.88 4.983v9.859h-3.464v-17.494h3.464v2.546a5.742 5.742 0 0 1 4.989-2.867 6.512 6.512 0 0 1 1.677.215",
    transform: "translate(-367.487 -337.687)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m649.278 374.893a9.388 9.388 0 1 1 -9.384-9.141 9.114 9.114 0 0 1 9.384 9.141m-15.418 0a6.034 6.034 0 1 0 6.034-5.987 5.876 5.876 0 0 0 -6.034 5.987",
    transform: "translate(-364.322 -337.696)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m664.341 374.893a9.39 9.39 0 1 1 -9.387-9.141 9.116 9.116 0 0 1 9.387 9.141m-15.421 0a6.034 6.034 0 1 0 6.034-5.987 5.876 5.876 0 0 0 -6.034 5.987",
    transform: "translate(-358.228 -337.696)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m690.164 373.028v10.572h-3.427v-9.89c0-2.976-1.714-4.8-4.506-4.8a4.428 4.428 0 0 0 -4.618 4.8v9.89h-3.427v-9.89c0-2.976-1.714-4.8-4.543-4.8-2.2 0-4.544 1.325-4.544 4.8v9.89h-3.462v-17.491h3.463v2.724a6.33 6.33 0 0 1 5.7-3.081c2.867 0 4.878 1.11 5.958 3.441a6.555 6.555 0 0 1 6-3.441c4.469 0 7.412 2.8 7.412 7.276",
    transform: "translate(-351.727 -337.696)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m492.231 388.282a3.26 3.26 0 0 1 0-4.733 28.42 28.42 0 0 1 -39.109 0 3.258 3.258 0 0 1 0 4.733 3.573 3.573 0 0 1 -4.918 0 35.569 35.569 0 0 0 48.944 0 3.574 3.574 0 0 1 -4.917 0",
    fill: "#3170b8",
    transform: "translate(-438.085 -331.432)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    transform: "translate(.012)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m451.12 394.58a3.573 3.573 0 0 1 4.918 0 25.95 25.95 0 0 1 0-37.64 3.574 3.574 0 0 1 -4.915 0 3.259 3.259 0 0 1 0-4.728 32.469 32.469 0 0 0 0 47.1 3.259 3.259 0 0 1 0-4.733",
    fill: "#0699a9",
    transform: "translate(-441.016 -342.463)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m453.416 388.538a3.258 3.258 0 0 0 0-4.733 3.573 3.573 0 0 0 -4.918 0 3.259 3.259 0 0 0 0 4.733 3.573 3.573 0 0 0 4.918 0",
    fill: "#9db0da",
    transform: "translate(-438.394 -331.687)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m453.124 354.741a3.259 3.259 0 0 1 0 4.733 28.456 28.456 0 0 1 39.106 0 3.261 3.261 0 0 1 0-4.731 3.573 3.573 0 0 1 4.912-.005 35.614 35.614 0 0 0 -48.939 0v.007-.005a3.573 3.573 0 0 1 4.918 0",
    fill: "#f57e29",
    transform: "translate(-438.101 -345)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m448.5 357.193a3.575 3.575 0 0 0 4.915 0 3.259 3.259 0 0 0 0-4.733 3.571 3.571 0 0 0 -4.916 0l-.006.005a3.259 3.259 0 0 0 0 4.728",
    fill: "#a1c7d1",
    transform: "translate(-438.378 -342.719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m485.486 354.572a3.272 3.272 0 0 1 -1.018 2.366 3.573 3.573 0 0 1 -4.918 0 25.915 25.915 0 0 1 0 37.642 3.576 3.576 0 0 1 4.918 0 3.261 3.261 0 0 1 0 4.733 32.436 32.436 0 0 0 0-47.11h-.007l.007.005a3.272 3.272 0 0 1 1.018 2.366",
    fill: "#ffe539",
    transform: "translate(-425.403 -342.465)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m479.842 352.46a3.261 3.261 0 0 0 0 4.731 3.571 3.571 0 0 0 4.916 0 3.259 3.259 0 0 0 0-4.733l-.006-.005a3.573 3.573 0 0 0 -4.912.005",
    fill: "#fbb480",
    transform: "translate(-425.695 -342.719)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m479.842 383.8a3.261 3.261 0 0 0 0 4.73 3.572 3.572 0 0 0 4.916 0 3.259 3.259 0 0 0 0-4.733l-.006-.005a3.573 3.573 0 0 0 -4.912.005",
    fill: "#fff1ac",
    transform: "translate(-425.695 -331.687)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#4d4d4f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m469.735 367.313a3.863 3.863 0 0 0 0-5.611 4.236 4.236 0 0 0 -5.829 0 3.865 3.865 0 0 0 0 5.611 4.236 4.236 0 0 0 5.829 0",
    transform: "translate(-432.22 -339.53)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m471.356 368.877a5.909 5.909 0 0 0 -8.13 0 5.409 5.409 0 0 0 -1.684 3.913v9.974h11.5v-9.974a5.414 5.414 0 0 0 -1.684-3.913",
    transform: "translate(-432.689 -337.166)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.74fb5d19668ff327b82af18db3c4c091.svg";
export { ForwardRef as ReactComponent };